import { getRequest } from '../../../services/base'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import {
  SalesCodesContext,
  SET_SALES_CODE_DATA,
  SET_SELECTED_SALES_CODE_DATA,
} from './context/context'
import SalesCodesRow from './SalesCodesRow'
import CreateUpdateSalesCode from './form'
import Button from '../../common/Button'
import InputText from '../../common/InputText'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const SalesCodesAndGroup = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [salesCodeState, salesCodeDispatch] = useContext(SalesCodesContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    getSalesCodeList(null)

    dispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'Sales Code And Group',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getSalesCodeList = async (url = null) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Sales Code Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(
      url ? url : `/api/sales_codes/?vehicle=${vehicle}&search=${searchValue}`
    )
    salesCodeDispatch({ type: SET_SALES_CODE_DATA, data: response.results })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <div className="w-full">
      <CreateUpdateSalesCode
        showModal={showModal}
        setShowModal={setShowModal}
        getSalesCodeList={getSalesCodeList}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          getSalesCodeList(null)
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Sales Code`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>

            <Button
              className={`cursor-pointer btn my-4 justify-end`}
              text={`Search`}
              onClick={() => {}}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">Name</div>
          <div className="flex w-4/12 pl-6 items-center">Description</div>
          <div className="flex w-2/12 pl-6 items-center">Group </div>
          <div className=" w-4/12 pl-6">Group Description</div>
          <div className="w-2/12 pl-6">Default</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {salesCodeState?.data?.map((sales_code, index) => {
        return (
          <SalesCodesRow
            {...sales_code}
            key={`sales-codes-${index}`}
            onEdit={() => {
              salesCodeDispatch({
                type: SET_SELECTED_SALES_CODE_DATA,
                data: { ...sales_code, index: index },
              })
              setShowModal(true)
            }}
            showDetails={() => {
              salesCodeDispatch({
                type: SET_SELECTED_SALES_CODE_DATA,
                data: { ...sales_code, index: index },
              })
            }}
          />
        )
      })}
      {salesCodeState?.data?.length < 1 && (
        <NoRecordsFound caption={"Sales code's not found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getSalesCodeList(e)
          }}
          onClickPrev={(e) => {
            getSalesCodeList(e)
          }}
        />
      </div>
    </div>
  )
}

export default SalesCodesAndGroup
